"use client";

import { CompositeContextProvider, CompositeScopedContextProvider } from "./APGXEJ2Q.js";
import { createStoreContext } from "./7FZLUSKW.js";

// src/tab/tab-context.tsx
var ctx = createStoreContext([CompositeContextProvider], [CompositeScopedContextProvider]);
var useTabContext = ctx.useContext;
var useTabScopedContext = ctx.useScopedContext;
var useTabProviderContext = ctx.useProviderContext;
var TabContextProvider = ctx.ContextProvider;
var TabScopedContextProvider = ctx.ScopedContextProvider;
export { useTabContext, useTabScopedContext, useTabProviderContext, TabContextProvider, TabScopedContextProvider };